import { Workspace } from "@common-models/workspace";
import { createSelector } from "@reduxjs/toolkit";
import { workspaceSelectors } from "@common-reducers/DBServiceThunks";
import { CommonRootState } from "@common/types/common-root-state-type";
import { debugLog } from "@common/utils/debug-logger";


export const testSelector = createSelector(
  [(state: CommonRootState) => state,
  (_, xxx: string) => xxx],
  (state: CommonRootState, xxx) => {
    debugLog('workspace-selectors', "param:" + xxx);
    return state.WorkspaceReducer.selectedWorkspaceId
  }
)

export const getSelectedWorkspace = createSelector(
  (state: CommonRootState) => state,
  (state: CommonRootState): Workspace | undefined => {
    let selectedWorkspace: Workspace | undefined;
    if (state.WorkspaceReducer.selectedWorkspaceId) {
      selectedWorkspace = workspaceSelectors.selectById(state, state.WorkspaceReducer.selectedWorkspaceId)
    }

    return selectedWorkspace;
  }
);

export const getWorkSpaceById = (workSpaceId: string) => createSelector(
  (state: CommonRootState) => state,
  (state): Workspace | undefined => {
    let selectedWorkspace;
    selectedWorkspace = workspaceSelectors.selectById(state, workSpaceId);

    return selectedWorkspace;
  }
);